import React, { memo, useState, useEffect, useCallback } from 'react'

import Button from '@material-ui/core/Button'
import Snackbar from '@material-ui/core/Snackbar'

const UpdateApp = memo(() => {
  const [waiting, setWaiting] = useState()

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return

    let registration
    let worker

    const onStateChange = () => {
      if (worker.state === 'installed') {
        setWaiting(worker)
      }
    }

    const onUpdate = () => {
      worker = registration.installing
      worker?.addEventListener('statechange', onStateChange)
    }

    navigator.serviceWorker.getRegistration().then((r) => {
      registration = r
      setWaiting(registration?.waiting)
      registration?.addEventListener('updatefound', onUpdate)
    })

    return () => {
      registration?.removeEventListener('updatefound', onUpdate)
      worker?.removeEventListener('statechange', onStateChange)
    }
  }, [])

  const onClose = useCallback(() => {
    waiting?.postMessage({ type: 'SKIP_WAITING' })
    setWaiting()
  }, [waiting])

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={Boolean(waiting)}
      message="A new version of this app is available!"
      action={
        <Button variant="contained" color="primary" size="small" onClick={onClose}>
          UPDATE
        </Button>
      }
    />
  )
})

export default UpdateApp
